module.exports = __webpack_public_path__ + "assets/img/flamengo2.ddcab2f2.png";